// 거래 내역, 실시간 포지션, 차트에서 공통으로 사용한다. 수량은 백엔드에서
// 이미 정규화했으므로 여기서 증권사 ExecQty를 다시 해석하지 않는다.
export function remainingAfterExit(open, event, exitQty) {
  if (event.open_qty != null && Number.isFinite(Number(event.open_qty))) {
    return Math.max(0, Number(event.open_qty));
  }
  const before = Number(open.open_qty ?? open.qty ?? 1);
  return Math.max(0, before - Number(exitQty ?? event.qty ?? before));
}

export function cycleKey(trade) {
  return trade.tradeKey ?? `${trade.strategyId ?? trade.id}:${trade.tradeSeq ?? trade.entry_timestamp}`;
}

export function countEntries(trades) {
  return new Set(trades.map(cycleKey)).size;
}

// 이벤트를 먼저 기록 순서대로 복원한 뒤, 표시할 행만 정렬한다.
// LIVE는 기존처럼 상단에 유지하며, 청산 행은 라인과 관계없이 최신 체결 시각순이다.
export function sortTradesByExitTime(trades) {
  const time = (value) => {
    const ms = value ? Date.parse(value) : NaN;
    return Number.isFinite(ms) ? ms : -Infinity;
  };
  return trades
    .map((trade, index) => ({ trade, index }))
    .sort((a, b) => {
      if (Boolean(a.trade.live) !== Boolean(b.trade.live)) return a.trade.live ? -1 : 1;
      const key = a.trade.live ? 'entry_timestamp' : 'exit_timestamp';
      const aTime = time(a.trade[key]);
      const bTime = time(b.trade[key]);
      if (aTime !== bTime) return bTime - aTime;
      // 같은 시각에 체결된 분할 청산은 나중에 기록된 행을 먼저 표시한다.
      return b.index - a.index;
    })
    .map(({ trade }) => trade);
}

export function closedTradeCycles(trades) {
  const groups = new Map();
  for (const trade of trades) {
    if (trade.live || !trade.exit_timestamp) continue;
    const key = cycleKey(trade);
    const group = groups.get(key) ?? { profit: 0, qty: 0, legs: 0, final: null };
    group.profit += Number(trade.profit) || 0;
    group.qty += Number(trade.qty) || 0;
    group.legs += 1;
    if (trade.is_final ?? (Number(trade.open_qty ?? 0) === 0)) group.final = trade;
    groups.set(key, group);
  }
  return [...groups.values()].filter(g => g.final).map(g => ({
    ...g.final, profit: g.profit, qty: g.qty, hasPartialExits: g.legs > 1,
  }));
}
